import DashboardScreen from "./Dashboard";
import ExpensesScreen from "./Expenses";
import RecipesScreen from "./Recipes";
import FuelingScreen from "./Fueling";
import TollsScreen from "./Tolls";
import MaintenanceScreen from "./Maintenance";
import SettingsPage from "./Settings";
import UnauthorizedScreen from "./Unauthorized";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  DashboardScreen,
  ExpensesScreen,
  RecipesScreen,
  FuelingScreen,
  TollsScreen,
  MaintenanceScreen,
  SettingsPage,
  UnauthorizedScreen,
};
